import { render, staticRenderFns } from "./IncentiveRequests.vue?vue&type=template&id=4322595e&"
import script from "./IncentiveRequests.vue?vue&type=script&lang=js&"
export * from "./IncentiveRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports